import React, { FC } from 'react';
import { Badge } from '@shopify/polaris';

interface StatusBadgeProps {
  success: boolean;
}

export const StatusBadge: FC<StatusBadgeProps> = ({ success }) => {
  if (success) {
    return (<Badge status="success">Connected</Badge>);
  }

  return (<Badge status="warning">Needs Setup</Badge>);
};
